import { render, staticRenderFns } from "./AdvertStatus.vue?vue&type=template&id=5d6e6048&scoped=true"
import script from "./AdvertStatus.vue?vue&type=script&lang=js"
export * from "./AdvertStatus.vue?vue&type=script&lang=js"
import style0 from "./AdvertStatus.vue?vue&type=style&index=0&id=5d6e6048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e6048",
  null
  
)

export default component.exports